'use client'

import { CompareToggle } from '@/components/client/directory/compare-toggle'
import { trackCustomEvent } from '@/hooks/client/use-analytics-engine'
import { useCompared } from '@/hooks/client/use-compared'
import { useTranslation } from '@/hooks/client/use-translation'
import { EventType } from '@/lib/analytics/events'

// Per-card add-to-comparison island for the brand-lineup blok. Shares state
// with every other card (and the directory) via useCompared; fires the SAME
// event name the directory fires so historical compare-add analytics line up,
// with `origin` marking the surface.
export const LineupCompareToggle = ({ slug }: { slug: string }) => {
  const { isCompared, toggle, atMax } = useCompared()
  const { t } = useTranslation()

  const handleToggle = () => {
    if (!isCompared(slug)) {
      trackCustomEvent('compare-add-product--click', EventType.Click, { eventRelease: slug, origin: 'brand-lineup' })
    }
    toggle(slug)
  }

  return (
    <CompareToggle
      isChecked={isCompared(slug)}
      onToggle={handleToggle}
      hidden={atMax}
      addLabel={t('aria.addToCompare', 'Add to comparison')}
      removeLabel={t('aria.removeFromCompare', 'Remove from comparison')}
    />
  )
}
